<script setup>
const props = defineProps({
  includeNumber: { type: Boolean, default: false },
  hostedFieldsStyles: { type: Object, required: true },
  hostDomReady: { type: Boolean, default: false },
})

const braintree = useBraintree()
const instance = ref(null)

const initializeInstance = async () => {
  try {
    if (!instance.value) {
      instance.value = await braintree.getHostedFieldsInstance(
        !props.includeNumber,
        props.hostedFieldsStyles,
      )
    }
  } catch {
    instance.value = null
  }
}

const teardownInstance = () => {
  instance.value?.teardown()
  instance.value = null
}

watch(
  () => props.hostDomReady,
  (newVal) => (newVal ? initializeInstance() : teardownInstance()),
)
</script>

<template>
  <div>
    <ClientOnly><slot :hosted-fields-instance="instance" /></ClientOnly>
  </div>
</template>
